module.exports = __webpack_public_path__ + "static/img/Dog-1.6f083e07.png";